let amaDebug: boolean | undefined;
const DEBUG_COOKIE = 'adsdebug';

export const isDebugTs = (): boolean => {

  if(typeof amaDebug !== 'undefined') return amaDebug;

  if(window.location.search.includes('adsdebug=1')) {
    amaDebug = true;
    sessionStorage.setItem(DEBUG_COOKIE, '1');
  } else  {
      amaDebug = !!sessionStorage.getItem(DEBUG_COOKIE);
  }
  return amaDebug
}

export const isDebugTopAdTs = window.location.search.includes('adsdebug=12');

export default function amaLog(...args: any[]): void {
  if (isDebugTs()) {
    if (!amaDebug) {
      amaDebug = true;
    }
    console.log('%cDFP Ads', 'color: green;', '-', ...args);
  }
}

export function amaAlert(...args: any[]): void {
  if (isDebugTs()) {
    console.log('%cDFP Ads', 'color: red;', '-', ...args);
  }
}

export function amaWarn(...args: any[]): void {
  if (isDebugTs()) {
    console.log('%cDFP Ads', 'color: orange;', '-', ...args);
  }
}


